import TransaksiPenghapusan from "./views/TransaksiPenghapusan.vue";

const requireAuth = {requireAuth: true}

const moduleRoute = {
  path: '/penghapusan_transaksi_global',
  name: "TransaksiDanPenghapusan",
  component: TransaksiPenghapusan,
  meta: requireAuth,
}

export default router => {
  router.addRoutes([moduleRoute])
}